import * as React from 'react';
import styled from 'styled-components';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { GrammarReadingStatus } from '../../home-page/components/GrammarReadingStatus';
import { LineDivider } from '@doltech/ui/lib/figma/Divider/LineDivider';
import {
  TimerDoTestGrammar,
} from './TimerDoTestGrammar';
import {
  ViewMultiStudents,
} from './ViewMultiStudents';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { ReadDoStatusEnum } from '../../shared/constants';
import { isEmpty } from 'lodash';

const Container = styled.aside`
  display: grid;
  grid-template-columns: minmax(0, 320px);
  margin-right: 24px;
  column-gap: 20px;
`;

const TopWrapper = styled.div`
  ${verticalSpace(16)};

  ${fromScreen(1240)} {
    ${verticalSpace(20)};
  }
`;

const TextWrapper = styled.div`
  ${verticalSpace(12)};
`;

interface SideInfoReadingInfoProps {
  title?: string;
  type?: 'theory' | 'exercise';
  status?: ReadDoStatusEnum;
  time?: string;
  lastAccess?: string;
  users?: any[];
  statusPosition?: 'top' | 'bottom';
  hasTimeCounter?: boolean;
}

export const SideInfoReadingInfo = (props: SideInfoReadingInfoProps) => {
  const { type, title, status, time, lastAccess, users, statusPosition = 'bottom', hasTimeCounter = true } = props;

  return (
    <Container>
      <TopWrapper>
        <TextWrapper>
          {statusPosition === 'top' &&
            <GrammarReadingStatus
              type={type}
              status={status}
            />}
          {title &&
            <ResponsiveTypography.Paragraph variant="semi-bold/16-28" color="gray180" ellipsis={{ tooltip: true }}>
              {title}
            </ResponsiveTypography.Paragraph>}
          {statusPosition === 'bottom' &&
            <GrammarReadingStatus
              type={type}
              status={status}
            />}
        </TextWrapper>
        {!isEmpty(users) && (
          <ViewMultiStudents
            type={type}
            users={users}
            maxCount={8}
          />
        )}
      </TopWrapper>
      {hasTimeCounter && <>
        <LineDivider/>
        <TimerDoTestGrammar
          time={time}
          lastAccess={lastAccess}
        />
      </>}
    </Container>
  );
};
